import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion"
export default class extends Controller {
  toggleAccordion(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    const icon = trigger.querySelector('.icon-arrow-right')
    const panel = trigger.parentElement.querySelector('.accordion-panel')

    if (icon) {
      icon.classList.toggle("rotated")
    }
    panel.classList.toggle("open")
  }
}
